import { lazy } from "react";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";
import { RoleGuard } from "../contexts/RoleGuard"; // Import RoleGuard
import { Outlet } from "react-router";
import ActivityLogsService from "../contexts/services/activity-logs-service/ActivityLogsService";

const ActivityLogs = ScreenLoader(
  lazy(() => import("../screens/activity-logs/ActivityLogsScreen")),
);

export const AcitiviyLogsRoute = () => ({
  path: "activity-logs",
  element: (
    <AuthGuard>
      <RoleGuard requiredPermission="adminLog" requiredActions={["isRead"]}>
        <ActivityLogsService>
          <Outlet />
        </ActivityLogsService>
      </RoleGuard>
    </AuthGuard>
  ),
  children: [
    {
      path: "",
      element: <ActivityLogs />,
    },
  ],
});
